import { message } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { SubmissionState } from "../types/RequestTypes";
import _ from "lodash";

export const COL_SPAN = {
  desktop: [3, 9],
  tablet: [4, 8],
  mobile: [9, 15],
};
export const SELECT_PROPS = {
  desktop: { span: 12, style: { paddingRight: "2rem" } },
  tablet: { span: 24 },
  mobile: { span: 24 },
};

export const REQUEST_COL_SPAN = {
  desktop: [6, 6],
  tablet: [6, 6],
  mobile: [12, 12],
};

export const MAX_HR_PER_DAY = 24;
export const MIN_HR_PER_DAY = 0;
export const PAST_MONTH = 12;

export const CLAIM_STATUS: { [key: string]: SubmissionState } = {
  DRAFT: "I",
  SUBMITTED: "W",
  ENDORSED: "S",
  APPROVED: "P",
  REJECTED: "R",
  PAID: "PP",
};
export const STATUS_ARRAY: SubmissionState[] = ["I", "W", "S", "P", "R", "PP"];
export const APPROVER_STATUS_ARRAY: SubmissionState[] = ["W", "S"];
export const ENDORSER_STATUS_ARRAY: SubmissionState[] = ["W"];

export const StatusWithEle = {
  I: { color: "yellow", text: "Draft" },
  W: { color: "green", text: "Submitted" },
  S: { color: "blue", text: "Endorsed" },
  P: { color: "purple", text: "Approved" },
  R: { color: "magenta", text: "Rejected" },
  PP: { color: "lawngreen", text: "Paid" },
};

export const StatusFilters = {
  filters: [
    { text: "Draft", value: "I" },
    { text: "Submitted", value: "W" },
    { text: "Endorsed", value: "S" },
    { text: "Approved", value: "P" },
    { text: "Rejected", value: "R" },
    { text: "Paid", value: "PP" },
  ],
  onFilter: (value, record) => {
    let newStatus = statusProcess(record);
    return newStatus === value;
  },
};

export const RateType = {
  H: "Hourly",
  L: "Lump Sum",
  M: "Monthly",
};

export const formItemLayout = {
  desktop: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
  tablet: null,
  mobile: null,
};

export const requestformItemLayout = {
  desktop: { labelCol: { span: 8 } },
  tablet: { labelCol: { span: 5 }, wrapperCol: { span: 19 } },
  mobile: null,
};

export const statusProcess = (record: any) => {
  let newStatus = record.STATUS;
  if (record.STATUS === "P" && record?.IS_PAID && record?.IS_PAID === 1) {
    newStatus = "PP";
  } else if (record.STATUS === "S" && !record.ENDORSER) {
    newStatus = "W";
  }
  return newStatus;
};

export const floatString = (s: string, type: "String" | "Float") => {
  let multiplyer = 100;
  return parseFloat(s)
    ? (Math.round(parseFloat(s) * multiplyer) / multiplyer).toString()
    : "";
};

export const errorMsg = (error: string) => {
  if (error.startsWith("ORA")) {
    message.error("Please retry or contact administrator.");
    //SEND TO MC_LOG
  } else {
    message.error(error);
  }
};

export const STRING_DATE = "DD-MMM-YYYY";
export const CALENDAR_DATE = "YYYYMMDD";

export const todayWithRange = (start: Dayjs, end: Dayjs) => {
  return dayjs().isBefore(start, "date")
    ? start
    : dayjs().isAfter(end, "date")
    ? end
    : dayjs();
};

export const selectFUNC = (rateType, functions) => {
  let func;
  switch (rateType) {
    case "H":
      func = _.find(functions, { COMPONENT: "HourlyPage" });
      break;
    case "M":
      func = _.find(functions, { COMPONENT: "MonthlyPage" });
      break;
    case "L":
      func = _.find(functions, { COMPONENT: "LumpSumPage" });
      break;
    default:
      return;
  }
  return func;
};

export enum PTPS_FUNC_TYPE {
  GENERAL = 1,
  ADIMN = 2,
}